<template>
    <div class="general">
        <strong class="title">{{ titulo }}</strong>
        <div class="photos-gallery">
            <span class="col-6" v-for="(photo, index) in photos" v-bind:key="index">
                <img
                    class="photo mb-0"
                    :src="photo.image_base64"
                    :id="photo.ordem"
                    :alt="photo.photoName"
                    @click="selectPhoto(photo, index)"
                    v-bind:class="{
                        selected:
                            photos[index].selected && photos[index].selected === true,
                        updateView: updateViewComponent,
                    }"
                />
                <div v-if="photo.image_name">
                    <p class="text-center text-photo">{{ photo.photoName }}</p>
                </div>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Gallery",
    props: {
        titulo: String,
        uuid: String,
        photos: Array,
        templates: Array,
        selectionMode: Boolean,
        isDelete: Boolean,
        takenPhoto: Object,
    },
    data: function () {
        return {
            photosList: [],
            selectedPhotosIndex: [],
            updateViewComponent: true,
        };
    },
    methods: {
        updateStoreState: function () {
            this.$store.dispatch("updatePhotos", {
                collectionId: this.uuid,
                photos: this.photos,
            });
        },
        cleanAllSelections: function () {
            this.photos.forEach((photo, index) => {
                this.photos[index].selected = false;
            });
            this.selectedPhotosIndex = [];
            this.updateViewComponents();
        },
        selectPhoto: function (photo, index) {
            if (this.selectionMode) {
                if (this.photos[index].selected && this.photos[index].selected === true) {
                    this.photos[index].selected = false;
                    const itemRemovido = this.selectedPhotosIndex.findIndex(
                        (item) => item === index
                    );
                    this.selectedPhotosIndex.splice(itemRemovido, 1);
                } else {
                    this.photos[index].selected = true;
                    this.selectedPhotosIndex.push(index);
                }
            } else {
                this.$emit("takePhoto", photo);
            }
            this.updateViewComponents();
        },
        deleteSelections: async function () {
            if (this.selectionMode) {
                const indexOfDeleteItens = this.selectedPhotosIndex;

                for await (let indexPhotoDelete of indexOfDeleteItens) {
                    indexOfDeleteItens.splice(
                        indexOfDeleteItens.indexOf(indexPhotoDelete),
                        1
                    );
                    const photoDelete = this.photos[indexPhotoDelete];

                    if (this.templates && this.templates.length > 0) {
                        const templateReferente = this.templates.find(
                            (template) => template.photoName === photoDelete.photoName
                        );
                        this.photos.splice(indexPhotoDelete, 1, templateReferente);
                    } else {
                        this.photos.splice(indexPhotoDelete, 1);
                    }
                }
                this.updateViewComponents();
                this.$emit("deleteEnd");
            }
        },
        updatePhotoOrAddNew: function (takenPhoto) {
            const photos = this.photos;
            const fotoAlterada = photos.find(
                (item) => item && item.photoName === takenPhoto.photoName
            );

            if (fotoAlterada) {
                const indexPhotoAlterada = photos.indexOf(fotoAlterada);
                photos.splice(indexPhotoAlterada, 1, takenPhoto);
            } else {
                photos.push(takenPhoto);
            }
        },
        updateViewComponents: function () {
            this.updateViewComponent = !this.updateViewComponent;
        },
    },
    watch: {
        photos() {
            this.updateStoreState(this.photos);
        },
        selectionMode() {
            if (!this.selectionMode) {
                this.cleanAllSelections();
            }
        },
        isDelete() {
            if (this.isDelete) {
                this.deleteSelections();
            }
        },
    },
    mounted: function () {
        if (this.takenPhoto) {
            this.updatePhotoOrAddNew(this.takenPhoto);
        }
    },
};
</script>

<style scoped>
.general {
    text-align: center;
    background-color: #fff;
    padding: 14px 0px;
}

.title {
    font-size: 14px;
    margin-bottom: 8px;
    color: #202020;
}

.photo {
    width: 80vh;
    height: calc(100vw / 3.385);
    object-fit: cover;
    margin-bottom: 20px;
}

.selected {
    filter: brightness(50%);
    border: 2px solid rgb(199, 199, 199);
}

.photos-gallery {
    padding-top: 10px;
    padding-bottom: 80px;
    display: flex;
    flex-wrap: wrap;
}

.text-photo {
    color: white;
    background-color: black;
    font-size: 0.6rem;
}
</style>
